/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAssignmentUser } from './InternalApiAssignmentUser';
import {
    InternalApiAssignmentUserFromJSON,
    InternalApiAssignmentUserFromJSONTyped,
    InternalApiAssignmentUserToJSON,
    InternalApiAssignmentUserToJSONTyped,
} from './InternalApiAssignmentUser';

/**
 * 
 * @export
 * @interface InternalApiAlertAssignment
 */
export interface InternalApiAlertAssignment {
    /**
     * 
     * @type {number}
     * @memberof InternalApiAlertAssignment
     */
    id: number;
    /**
     * 
     * @type {InternalApiAssignmentUser}
     * @memberof InternalApiAlertAssignment
     */
    assignee: InternalApiAssignmentUser;
    /**
     * 
     * @type {InternalApiAssignmentUser}
     * @memberof InternalApiAlertAssignment
     */
    assigner?: InternalApiAssignmentUser;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiAlertAssignment
     */
    startTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiAlertAssignment
     */
    endTime?: Date;
}

/**
 * Check if a given object implements the InternalApiAlertAssignment interface.
 */
export function instanceOfInternalApiAlertAssignment(value: object): value is InternalApiAlertAssignment {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('assignee' in value) || value['assignee'] === undefined) return false;
    return true;
}

export function InternalApiAlertAssignmentFromJSON(json: any): InternalApiAlertAssignment {
    return InternalApiAlertAssignmentFromJSONTyped(json, false);
}

export function InternalApiAlertAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAlertAssignment {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'assignee': InternalApiAssignmentUserFromJSON(json['assignee']),
        'assigner': json['assigner'] == null ? undefined : InternalApiAssignmentUserFromJSON(json['assigner']),
        'startTime': json['startTime'] == null ? undefined : (new Date(json['startTime'])),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
    };
}

export function InternalApiAlertAssignmentToJSON(json: any): InternalApiAlertAssignment {
    return InternalApiAlertAssignmentToJSONTyped(json, false);
}

export function InternalApiAlertAssignmentToJSONTyped(value?: InternalApiAlertAssignment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assignee': InternalApiAssignmentUserToJSON(value['assignee']),
        'assigner': InternalApiAssignmentUserToJSON(value['assigner']),
        'startTime': value['startTime'] == null ? value['startTime'] : value['startTime'].toISOString(),
        'endTime': value['endTime'] == null ? value['endTime'] : value['endTime'].toISOString(),
    };
}

